'use client';

import {useMemo} from 'react';

import useBreakpoints from './useBreakpoints';

function useMobile() {
  const {init, lg, sm} = useBreakpoints();

  const showOnMobile = useMemo(() => {
    if (init) return !lg;
    return sm;
  }, [init, lg, sm]);

  return showOnMobile;
}

export default useMobile;
